import React, { useState, useEffect } from "react";
import {
  MDBCol, MDBDropdown, MDBDropdownMenu,
  MDBDropdownToggle, MDBDropdownItem, MDBIcon
} from 'mdb-react-ui-kit';
import InputField from "../../../Components/InputField";

const FILTER_OPTIONS = [
  { text: "is equal to", value: "isEqualTo" },
  { text: "starts with", value: "startsWith" },
  { text: "contains", value: "contains" },
  { text: "ends with", value: "endsWith" },
  { text: "is different from", value: "isDifferentFrom" },
  { text: "does not start with", value: "doesNotStartWith" },
  { text: "does not contain", value: "doesNotContain" },
  { text: "does not end with", value: "doesNotEndWith" },
];

const FilterInput = ({ label, onFilterUpdate, columnKey, isResetting }) => {
  const [filter, setFilter] = useState({ type: '', text: '' });

  useEffect(() => {
    if (isResetting) {
      setFilter({ type: '', text: '' });
      return;
    }

    onFilterUpdate(columnKey, {
      filterText: String(filter.text).toLowerCase(),
      filterType: filter.type
    });
  }, [filter, isResetting]);

  return (
    <MDBCol md="2" className="mb-4 d-flex flex-wrap" style={{ minWidth: 'max-content' }}>
    <MDBCol md="10" className="p-0">
      <InputField
        type="text"
        label={label}
        value={filter.text}
        onChange={(e) => setFilter({ ...filter, text: e.target.value })}
      />
    </MDBCol>
    <MDBCol md="2" className="p-0">
      <FilterDropdown
        value={filter.type}
        onValueChange={(type) => setFilter({ ...filter, type })}
      />
    </MDBCol>
  </MDBCol>

  );
};

const FilterDropdown = ({ value, onValueChange }) => (
  <MDBDropdown>
    <MDBDropdownToggle tag='a' style={{ padding: '10px' }}>
      <MDBIcon fas icon="filter" className="filter-icon" style={{ color: value ? '#005595' : 'lightblue' }} />
    </MDBDropdownToggle>
    <MDBDropdownMenu>
      {FILTER_OPTIONS.map(option => (
        <MDBDropdownItem
          link
          key={option.value}
          onClick={() => onValueChange(option.value)}
          className={option.value === value ? 'active' : ''}
        >
          {option.text}
        </MDBDropdownItem>
      ))}
    </MDBDropdownMenu>
  </MDBDropdown>
);

export default FilterInput;
